<template>
  <b-container id="forgot-password">
    <mtg-header/>
    <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
      <b-container class="container--max-610 mt-3 mt-md-4">
        <b-card>
          <h1 class="h3">{{ $t("lang.label_password_reset") }}</h1>
          <p>{{ $t("lang.label_user_forgot_password_label") }}</p>
          <b-form-group :label="$t('lang.label_email')" label-for="email">
            <div class="position-relative">
              <b-form-input v-model="email" id="email" type="email" required
                            :placeholder="$t('lang.label_placeholder_email')"></b-form-input>
              <b-form-invalid-feedback>{{ $t("lang.label_email_feedback") }}</b-form-invalid-feedback>
            </div>
            <b-row class="mt-5">
              <b-col sm>
                <p>
                  <router-link :to="{ name: 'login' }">{{ $t("lang.label_signIn") }}</router-link>
                </p>
              </b-col>
              <b-col sm class="text-right">
                <b-button variant="primary" type="submit" :disabled="isLoading">{{ $t("lang.label_submit") }}</b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
      </b-container>
    </b-form>
  </b-container>
</template>
<script>
import MtgHeader from "../components/layout/MtgHeader";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: this.$route.params.givenUserEmail,
      wasValidated: false
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters["isLoading"];
    }
  },
  methods: {
    onSubmit(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasValidated = true;
        return;
      }
      this.resetPassword();
    },
    resetPassword() {
      var userEmail = this.email;
      this.$store
          .dispatch("auth/resetPassword", {email: userEmail})
          .then(() => {
            this.$router.push({name: "reset-password-email-notification", params: {userEmail}});
          })
          .catch(() => {
              this.$router.push({name: "reset-password-email-notification", params: {userEmail}});
          });
    }
  },
  components: {
    MtgHeader
  }
};
</script>
<style scoped></style>
